import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import VendorsPageUI from './VendorsPageUI.js'

class VendorsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      vendorList: null,
      searchFilter: '',
      createMode: false,
      panCreateMode: false
    }
  }

  render() {
    return (
      <VendorsPageUI
        context={this.props.context}
        account={this.state.account}
        onSubmit={this.state.onSubmit}
        vendorList={this.state.vendorList}
        createMode={this.state.createMode}
        panCreateMode={this.state.panCreateMode}
        onVendorCreateClick={() => { this.setState({ 'createMode': true }) }}
        onCancelClick={() => { this.setState({ 'createMode': false }) }}
        onVendorPanCreateClick={() => { this.setState({ 'panCreateMode': true }) }}
        onCancelPanClick={() => {this.setState({ 'panCreateMode': false })}}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getVendors(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }
  
  getVendors(context){
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/vendors`,
      cacheKey: CacheKeys.Vendors(this.props.match.params.accountId),
      callback: this.getVendorsCallback,
      ttlInSecs: 600
  })
  cacheManager.getObject2(context)
  }
  getVendorsCallback = (response) => {
    this.setState({
      vendorList: response.vendorList
    })
  }
  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.vendorList, searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Vendors(this.props.match.params.accountId))
    this.setState({ vendorList: null },
      this.getVendors(context),
    )
  }
}

export default withRouter(VendorsPageSF)
